import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

enum DateFilterEnum {
  NONE = 'NONE',
  THIS_YEAR = 'THIS_YEAR',
  THIS_MONTH = 'THIS_MONTH',
  TODAY = 'TODAY',
  CUSTOM = 'CUSTOM',
}

export interface JobOrderFilters {
  jobCustomer: string;
  jobName: string;
  jobMachine: string;
  date: string;
  fromDate: Date;
  toDate: Date;
}
@Component({
  selector: 'app-job-order-filter-component',
  templateUrl: './job-order-filter.component.html',
  styleUrls: ['./job-order-filter.component.scss'],
})
export class JobOrderFilterComponent implements OnInit {
  @Output()
  apply: EventEmitter<JobOrderFilters> = new EventEmitter();

  formGroup = new FormGroup({
    jobCustomer: new FormControl(''),
    jobName: new FormControl(''),
    jobMachine: new FormControl(''),
    date: new FormControl(DateFilterEnum.NONE),
    fromDate: new FormControl({ value: '', disabled: true }),
    toDate: new FormControl({ value: '', disabled: true }),
  });

  constructor() {}

  ngOnInit(): void {}

  onChange() {
    switch (this.formGroup.value.date) {
      case 'CUSTOM': {
        // Enable custom date selection fields
        this.formGroup.controls.fromDate.reset({
          value: this.formGroup.value.fromDate,
          disabled: false,
        });
        this.formGroup.controls.toDate.reset({
          value: this.formGroup.value.toDate,
          disabled: false,
        });
        break;
      }
      default: {
        this.formGroup.controls.fromDate.reset({
          value: this.formGroup.value.fromDate,
          disabled: true,
        });
        this.formGroup.controls.toDate.reset({
          value: this.formGroup.value.toDate,
          disabled: true,
        });
      }
    }
  }

  onApply() {
    let fromDate = this.formGroup.value.fromDate;
    let toDate = this.formGroup.value.toDate;
    const today = new Date();
    switch (this.formGroup.value.date) {
      case 'THIS_YEAR':
        fromDate = new Date(new Date().getFullYear(), 0, 1);
        toDate = new Date(new Date().getFullYear(), 11, 31);
        break;

      case 'THIS_MONTH':
        fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
        toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;

      case 'TODAY':
        fromDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          0,
          1
        );
        toDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          23,
          59
        );
        break;

      default:
        break;
    }
    this.apply.emit({
      ...this.formGroup.value,
      fromDate,
      toDate,
    });
  }
}
